import * as React from "react";
import { ServiceAccountCreateForm } from "./form";

export const ServiceAccountCreateInitializer: React.FC = () => {
  return <ServiceAccountCreateForm />;
};
